<template>
  <div class="wegow-select">
    <label
      v-if="label"
      :id="`${id}__wegow-select_label_`"
      :class="smallLabel ? 'text-mm' : 'text-lg'"
      :for="labelFor"
    >
      {{ label }}
      <!-- <wegow-tooltip
        v-if="(tooltipText || personalizedTooltip) && label"
        :show-tooltip="showTooltip"
        class="ml-4"
        @change-tooltip="showTooltip = $event"
      ></wegow-tooltip> -->
    </label>
    <span
      v-if="showTooltip && label"
      class="text-s block font-light text-grayDescription my-2"
    >
      <div v-if="personalizedTooltip">
        <slot name="tooltip"></slot>
      </div>
      <div v-else>{{ tooltipText }}</div>
    </span>
    <div class="flex" :class="{ height: height !== '' }">
      <VueMultiselect
        :id="id"
        ref="multiselect"
        :model-value="value"
        :options="options"
        :loading="loading"
        :custom-label="customLabel"
        :placeholder="placeholder"
        :show-labels="false"
        :multiple="multiple"
        :disabled="disabled"
        :class="{
          bigger: !multiple && value && !disabled && removable,
          'small-content': smallContent,
          focus: isFocus,
          error: errorMessage,
          'cursor-not-allowed': disabled,
          'background-transparent': backgroundSelect,
          'font-color': fontColor,
          'border-color': borderSelect,
          'select-config': border !== ''
        }"
        :track-by="trackBy ? trackBy : objectLabel"
        :internal-search="hasInternalSearch"
        :aria-expanded="openSelect"
        @search-change="searchChanged"
        @select="select"
        @input="input"
        @remove="remove"
        @click="openSelect = true"
      >
        <template v-if="specialSingleLabel" #singleLabel="data">
          <slot name="singleLabel" :data="data"> {{ data }} </slot>
        </template>
        <template #noOptions>
          <span v-if="noOptionsLabel !== ''">
            {{ $t(noOptionsLabel) }}
          </span>
          <span v-else>
            {{ $t("wegow.filters.emptyList") }}
          </span>
        </template>
        <template #noResult>
          <span v-if="noResultLabel !== ''">
            {{ $t(noResultLabel) }}
          </span>
          <span v-else>
            {{ $t("wegow.filters.searchNoResult") }}
          </span>
        </template>
        <template v-if="specialLabel" #option="data">
          <slot name="option" :data="data"> {{ data }} </slot>
        </template>
      </VueMultiselect>
      <!-- <wegow-tooltip
        v-if="(tooltipText || personalizedTooltip) && !label"
        :show-tooltip="showTooltip"
        class="mx-2"
        :personalized-tooltip="personalizedTooltip"
        @change-tooltip="showTooltip = $event"
      ></wegow-tooltip> -->
    </div>
    <span
      v-if="showTooltip && !label"
      class="text-s block font-light mb-1 text-grayDescription my-1 ml-2"
    >
      <div v-if="personalizedTooltip">
        <slot name="tooltip"></slot>
      </div>
      <div v-else>{{ tooltipText }}</div>
    </span>
    <small
      :id="`${id}__wegow-select_description_`"
      :class="{ hidden: !description }"
      class="text-mm block font-light mt-1"
      tabindex="-1"
    >
      {{ description }}
    </small>
    <!-- <wegow-error-message
      :class="{ hidden: !errorMessage }"
      :message="errorMessage ? $t(errorMessage) : '.'"
    /> -->
  </div>
</template>

<script>
import VueMultiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.css";
// import WegowErrorMessage from "@/components/ui/WegowErrorMessage";
// import WegowTooltip from "@/components/ui/WegowTooltip";

export default {
  components: {
    // WegowErrorMessage,
    // WegowTooltip,
    VueMultiselect
  },
  props: {
    fontColor: {
      type: String,
      default: ""
    },
    id: {
      required: true,
      type: String
    },
    description: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    labelFor: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    noOptionsLabel: {
      type: String,
      default: ""
    },
    noResultLabel: {
      type: String,
      default: ""
    },
    objectLabel: {
      type: String,
      default: ""
    },
    options: {
      type: Array,
      default: () => [],
      required: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    placeholder: {
      type: String,
      default: "Escoge una opción"
    },
    trackBy: {
      type: String,
      default: undefined
    },
    value: {
      type: [Object, String],
      default: () => {}
    },
    errorMessage: {
      type: String,
      required: false,
      default: ""
    },
    removable: {
      type: Boolean,
      required: false,
      default: false
    },
    deleteAccent: {
      type: Boolean,
      required: false,
      default: false
    },
    specialLabel: {
      type: Boolean,
      required: false,
      default: false
    },
    specialSingleLabel: {
      type: Boolean,
      default: false
    },
    smallLabel: {
      type: Boolean,
      default: false
    },
    smallContent: {
      type: Boolean,
      default: false
    },
    tooltipText: {
      type: String,
      required: false,
      default: ""
    },
    personalizedTooltip: {
      type: Boolean,
      required: false,
      default: false
    },
    makeServerCall: {
      type: Boolean,
      default: false
    },
    backgroundSelect: {
      type: String,
      default: ""
    },
    borderSelect: {
      type: String,
      default: ""
    },
    border: {
      type: String,
      default: ""
    },
    padding: {
      type: String,
      default: "9px 6px 0px 6px"
    },
    height: {
      type: String,
      default: ""
    }
  },
  emits: ["search-change", "select", "input", "remove"],
  data: () => {
    return {
      isFocus: false,
      showTooltip: false,
      showX: false,
      openSelect: false,
      borderInput: "",
      paddingInput: "",
      heightInput: ""
    };
  },
  computed: {
    // canEdit() {
    //   let role = this.$store.state.user.role[0];
    //   if (!role || role.role === 3 || role.role === 15) {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // },
    hasInternalSearch() {
      return this.loading && this.makeServerCall;
    }
  },
  mounted() {
    this.borderInput = this.border;
    this.paddingInput = this.padding;
    this.heightInput = this.height;
    this.$el.addEventListener
      ? this.$el.addEventListener("focus", this.onFocus, true)
      : this.$el.attachEvent("onfocusout", this.onFocus);
    this.$el.addEventListener
      ? this.$el.addEventListener("blur", this.onBlur, true)
      : this.$el.attachEvent("onblur", this.onBlur);
    window.addEventListener("focus", () => {
      let button = document.getElementById("invisibleButton");
      if (button) {
        button.focus();
      }
    });
    this.addDeleteButton(this.value);
  },
  methods: {
    onFocus() {
      this.isFocus = true;
    },
    onBlur() {
      this.isFocus = false;
    },
    searchChanged(value) {
      if (this.isFocus) {
        this.$emit("search-change", value);
      }
    },
    select(value) {
      this.$emit("select", value);
      this.addDeleteButton(value);
    },
    input(value) {
      this.$emit("input", value);
    },
    remove(value) {
      this.$emit("remove", value);
    },
    removeAll() {
      this.$emit("remove");
    },
    customLabel(data) {
      if (this.deleteAccent && data[this.objectLabel]) {
        return this.removeAccents(data[this.objectLabel]);
      }
      return data[this.objectLabel];
    },
    removeAccents(str) {
      if (str) {
        return str
          .normalize("NFD")
          .replace(
            /([^\u0300-\u036fn]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,
            "$1"
          )
          .normalize();
      }
      return "";
    },
    addDeleteButton(value) {
      if (
        !this.multiple &&
        !Array.isArray(value) &&
        value !== null &&
        !this.showX &&
        this.removable
      ) {
        let ID = this.id;
        this.showX = true;
        setTimeout(() => {
          const card = document.getElementById(ID).parentNode.parentNode;
          const btn = document.createElement("div");
          btn.className = "p-2 cursor-pointer rounded closeArrow";
          btn.textContent = "X";
          card.appendChild(btn);
          btn.addEventListener("click", () => {
            this.$refs.multiselect.deactivate();
            this.showX = false;
            if (btn.parentNode) {
              btn.parentNode.removeChild(btn);
            }
            this.$emit("remove");
          });
        }, 100);
      }
    }
  }
};
</script>

<style lang="scss">
@import "~@/assets/mixins/delete-scroll.scss";
.wegow-select {
  .multiselect__input::placeholder {
    color: white;
  }
  .transparent {
    ::-webkit-scrollbar-track {
      box-shadow: inset 0 0 6px transparent !important;
      background-color: transparent !important;
    }
    ::-webkit-scrollbar {
      width: 0px;
      height: 0px;
      background-color: transparent !important;
    }
    ::-webkit-scrollbar-thumb {
      background-color: transparent !important;
      border-radius: 0px;
      width: 0px;
    }
    .multiselect__option,
    .multiselect__spinner,
    input,
    .multiselect__single,
    .multiselect__content-wrapper,
    .multiselect__option,
    .multiselect__tags {
      background-color: transparent !important;
    }
    .multiselect__content-wrapper {
      border: 1px solid #7f8295 !important;
      background-color: #7f829556 !important;
      border-top: 0px !important;
    }
  }
  .multiselect__option,
  .multiselect__spinner,
  input,
  .multiselect__single {
    @apply bg-grayInput border border-grayInputBorder opacity-90;
    @apply w-full bg-grayInput text-grayInput border border-grayInputBorder rounded;
    color: $white;
  }

  .multiselect__tags {
    min-height: 38px;
    @apply w-full h-full bg-grayInput text-grayInput border border-grayInputBorder rounded;
    padding: v-bind(paddingInput);
  }
  .multiselect__content-wrapper {
    @apply bg-grayInput border border-grayInputBorder;
    @apply w-full bg-grayInput text-grayInput border border-grayInputBorder rounded;
    @include delete-scroll;
    color: $white;
  }
  .multiselect__content-wrapper ul li span {
    @apply hover:text-grayDetails opacity-90;
  }
  .multiselect__select::before {
    border: none;
    content: url("@/assets/images/ic-select-white.svg");
    margin-top: 50%;
    display: inline-block;
    width: 10px;
    height: 10px;
    // position: absolute;
    // top: 20%;
    // right: 4px;
  }
  .select-config {
    .multiselect__select::before {
      border: none;
      content: url("@/assets/images/ic-dropdown-grey.svg");
      margin-top: 0;
      display: inline-block;
      width: 21px;
      height: 21px;
      // position: absolute;
      // top: 20%;
      // right: 4px;
    }
  }

  .height {
    height: v-bind(heightInput);
  }

  .multiselect__select {
    width: auto;
    height: auto;
    color: #c4c4c4;
  }
  .multiselect__option {
    @apply bg-grayInput;
  }
  .multiselect__element {
    color: $white;
  }
  .multiselect__spinner::before,
  .multiselect__spinner::after {
    border-top-color: $topaz;
  }
  .multiselect__placeholder {
    margin-bottom: 0;
    padding-top: 0;
  }
  .multiselect__tag {
    @apply bg-wegowBase font-medium;
  }
  .font-color {
    .multiselect__single {
      color: v-bind(fontColor);
    }
  }
  .border-color {
    .multiselect__tags {
      border: $white solid 1px;
    }
  }
  .background-transparent {
    .multiselect__tags,
    // .multiselect__option,
    // .multiselect__spinner,
    input,
    .multiselect__single {
      background: transparent !important;
    }
  }
  // TODO: repasar, Start incomming changes

  .multiselect__tags,
  .multiselect__option,
  .multiselect__spinner,
  input,
  .multiselect__single {
    background: $inputLigthBackground;
    border: none;
    color: $white;
  }
  .multiselect__single,
  .multiselect__placeholder {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .multiselect__content-wrapper {
    border: none;
    // width: auto;  commented to limit the size to the input
    min-width: 100%;
    box-shadow: 0px 0px 4px 0px black;
  }
  .small-content .multiselect__content-wrapper {
    max-height: 500% !important;
  }
  .multiselect__option {
    &:hover {
      background: $backgroundchat;
    }
  }
  .multiselect__element {
    color: $white;
  }
  .multiselect__spinner::before,
  .multiselect__spinner::after {
    border-top-color: $topaz;
  }
  &__description {
    font-size: 10px;
  }
  .multiselect__tag {
    background: $topaz;
    color: black;
  }
  .closeArrow {
    background: $inputLigthBackground;
    color: #ff000070;
    position: absolute;
    right: 20px;
    top: 0;
    &:hover,
    &:focus {
      color: $red;
      text-shadow: 0px 0px 6px white;
    }
  }
  .multiselect--disabled,
  .multiselect--disabled .multiselect__current,
  .multiselect--disabled .multiselect__select {
    background: transparent;
  }

  .bigger {
    min-width: 90% !important;
  }
  & > div.flex {
    border: v-bind(borderInput) !important;
    border-radius: 4px !important;
  }
  .multiselect__option--highlight {
    background: $backgroundchat !important;
  }
  .multiselect__tag-icon:focus:after,
  .multiselect__tag-icon:hover:after {
    color: $red !important;
  }
  // .focus {
  //   box-shadow: 0px -2px 13px -2px black !important;
  // }
  .error {
    border: 1px solid $red;
  }
}
</style>
